"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hastToHtml5 = exports.domNodeToHastFragment = exports.domNodeToHast = exports.createFragment = exports.stringToHast = void 0;
var dom = __importStar(require("./dom"));
var serialization = __importStar(require("./serialization"));
var util_1 = require("./util");
/** Convert plaintext string to hast text node */
exports.stringToHast = function (text) { return ({
    type: 'text',
    value: text,
}); };
/** Create a fragment enclosing the given nodes */
exports.createFragment = function () {
    var nodes = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        nodes[_i] = arguments[_i];
    }
    return util_1.compressFragmentNode({
        type: 'element',
        tagName: 'fragment',
        children: nodes,
    });
};
/** Convert any dom node to hast, if possible */
exports.domNodeToHast = function (node, config) {
    return dom.nodeToHast(node, config);
};
/** Convert a dom node's content (i.e. children) to a hast fragment */
exports.domNodeToHastFragment = function (node, config) { return exports.createFragment.apply(void 0, dom.nodeChildrenToHastArray(node, config)); };
/** Convert hast to html5 string (fragment nodes will be stripped) */
exports.hastToHtml5 = function (node, config) {
    return serialization.hastNodeToUtf8Markup(node, config);
};
